import { httpRequest } from "@services/http";
import { BilledPeriods } from "@models/population.model";

/** Closed billing months a reset of this population would rewrite (MPN-1516).
 *
 *  Pre-flight for the reset and reprocess controls. The guard itself lives in
 *  the job, but a job that fails two seconds after the click is a poor way to
 *  learn that a month was invoiced — and the operator needs to see WHICH months
 *  before deciding whether an override is justified. */
export class CommandGetBilledPeriods {
  async run(populationSegmentId: number): Promise<BilledPeriods> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/populations/${populationSegmentId}/billed-periods/`;
    return httpRequest<BilledPeriods>(url, { method: "GET", cache: "no-store" });
  }
}
